<template>
  <label class="app-toggler">
    <div>
      <input
        type="checkbox"
        :name="name"
        class="app-toggler__input"
        v-bind="$attrs"
        @change="handleChange"
      />
      <p class="app-toggler__toggle"></p>
    </div>
    <app-title-box is-tooltip :tooltip="tooltip" :title="title"></app-title-box>
    <svg-icon v-if="image" :name="image" class="app-toggler__icon" />
  </label>
</template>

<script>
export default {
  name: 'AppToggler',
  components: {
    AppTitleBox: () => import('@/components/common/AppTitleBox'),
    SvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
    },
    name: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
  },
  data: (vm) => ({
    innerValue: vm.value,
  }),
  methods: {
    /**
     * Отпарвка родителю значение чекбокса
     */
    handleChange() {
      this.innerValue = !this.innerValue;
      this.$emit('input', this.innerValue);
    },
  },
};
</script>

<style lang="scss">
.app-toggler {
  position: relative;
  display: inline-block;
  padding: 15px;
  cursor: pointer;
  border: 1px solid #ededed;
  border-radius: 2px;

  &__toggle {
    position: relative;
    margin: 0 0 10px;

    &::before {
      position: relative;
      display: inline-block;
      width: 46px;
      height: 24px;
      content: '';
      background: #ececec;
      border-radius: 100px;
    }

    &::after {
      position: absolute;
      top: 2px;
      left: 2px;
      display: inline-block;
      width: 20px;
      height: 20px;
      content: '';
      background: #fff;
      border-radius: 100px;
      transition: all 0.15s linear;
    }
  }

  &__input {
    display: none;

    &:checked + .app-toggler__toggle {
      &::before {
        content: '';
        background: #02b55f;
      }

      &::after {
        left: 24px;
        content: '';
      }
    }
  }

  &__icon {
    position: absolute;
    top: 50%;
    right: 25px;
    width: 44px;
    height: 44px;
    margin-top: -22px;
  }
}
</style>
